// src/libs/i18n/locales.ts
import { EN_US, FR_FR, ES_ES } from './const';

export const allowedLocales = [EN_US, FR_FR, ES_ES] as const;

// Génère un type basé sur les locales définies
export type Locale = (typeof allowedLocales)[number];

// Associer les drapeaux aux langues
export const localeFlags: Record<Locale, string> = {
  [EN_US]: '🇺🇸',
  [FR_FR]: '🇫🇷',
  [ES_ES]: '🇪🇸',
};
export function isValidLocale(locale: string): locale is Locale {
  return allowedLocales.includes(locale as Locale);
}
